<template>
  <div>
    <v-card class="rounded-lg" elevation="0" color="#41916b">
      <v-card-title class="text-center justify-center">
          <h5 class="font-weight-bold" style="color: white">
          {{ donorLabel }}
          </h5>
      </v-card-title> 
      <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
          <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
          <v-tab>Anexos</v-tab>

          <v-tab-item>
              <v-card-text>
                <div
                  class=""
                  style="
                    border: solid 1px #e1e3e2;
                    border-radius: 15px;
                    padding: 15px;
                    width: 100%;
                    margin-top: 15px;
                  "
                >
                  <v-form @submit.prevent="addAttachment" ref="anexosForm">
                    <p style="font-weight: bold" v-if="$route.query.item ">
                      Paciente: {{ $route.query.item ? $route.query.item.name : "" }}
                    </p> 
                    <v-row dense>
                      <v-col class="d-flex" cols="12" sm="3">
                        <v-file-input
                          v-model="serologyAttachments.attachment"
                          class="rounded-lg"
                          color="black"
                          append-icon="mdi-file"
                          :rules="formRules"
                          prepend-icon=""
                          show-size
                          outlined
                          dense
                        >
                          <template v-slot:label>
                            Nome do Documento (PDF/PNG) <span style="color: red">*</span>
                          </template>
                        </v-file-input>
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="2"
                        v-if="['admin', 'gestor_hemoba'].includes(profile)"
                      >
                        <v-autocomplete
                          :rules="formRules"
                          :items="attachmentsTypes"
                          color="#256936"
                          class="rounded-lg"
                          v-model="serologyAttachments.attachments_type_id"
                          item-value="id"
                          item-text="name"
                          dense
                          outlined
                        >
                          <template v-slot:label>
                            Tipo do Documento <span style="color: red">*</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col class="d-flex" cols="12" sm="3">
                        <v-text-field
                          color="#086318"
                          class="rounded-lg"
                          :rules="formRules"
                          outlined
                          v-model="serologyAttachments.attachment_name"
                          dense
                        >
                          <template v-slot:label>
                            Descrição <span style="color: red">*</span>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="12"
                        :sm="['admin', 'gestor_hemoba'].includes(profile) ? '2' : '3'"
                      >
                        <v-text-field
                          color="#086318"
                          label="Observação"
                          class="rounded-lg"
                          outlined
                          v-model="serologyAttachments.observations"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col class="d-flex" cols="12" sm="2">
                        <v-tooltip right color="green">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="mx-1"
                              small
                              fab
                              dark
                              color="#41916b"
                              :loading="loadingButton"
                              v-bind="attrs"
                              v-on="on"
                              @click="addAttachment()"
                            >
                              <v-icon dark> mdi-plus </v-icon>
                            </v-btn>
                          </template>
                          <span style="color: white">Inserir Anexo</span>
                        </v-tooltip>
                        <p class="space"></p>
                      </v-col>
                    </v-row>
                  </v-form>

                  <template>
                    <v-data-table
                      :headers="headers"
                      :items="arquivos"
                      :footer-props="{ 'items-per-page-text': 'Anexos por Página' }"
                      :items-per-page="5"
                      class="elevation-1"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-icon
                          class="icon"
                          color="success"
                          align-item="center"
                          v-on="on"
                          v-bind="attrs"
                          @click="downloadAttachment(item)"
                        >
                          mdi-download
                        </v-icon>
                        <v-icon
                          class="icon"
                          color="red"
                          align-item="center"
                          @click="deleteAttachment(item)"
                          :disabled="permissionToDelete(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <template v-slot:[`item.observations`]="{ item }">
                        {{ item.observations ? item.observations : "-" }}
                      </template>
                    </v-data-table>

                    <BackToGridBtn route="/sorologia"/>
                  </template>
                </div>
              </v-card-text>
          </v-tab-item>

      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import axios from "@/axios";
import fileDownload from "js-file-download";
import { getSerologyList } from "@/service/SerologyService";
import { mapActions, mapGetters } from "vuex";
import currentUser from "@/utils/currentUser";
import { profileSlug } from "@/helpers/profileSlug";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
  data() {
    return {
      tab: 2, 
      serologyAttachments: {},
      donor: [],
      arquivos: [],
      formRules: [(v) => !!v || "Este campo é obrigatório"],
      loadingButton: false,
      headers: [
        {
          text: "Tipo do Anexo",
          align: "center",
          value: "type_of_attachments.name",
        },
        {
          text: "Descrição",
          align: "center",
          value: "attachment_name",
        },
        {
          text: "Observação",
          align: "center",
          value: "observations",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
    };
  },

  components: {
    BackToGridBtn
  },

  props:{
      bloodGroupId: Number
  },

  computed: {
    ...mapGetters({
          patientDonorId: "getDonorId",
          serologyDonor: "getSorologyPatientData",
          bloodDonor: "getBloodGroupsPatientData",
      }),

    donorName(){
      return this.serologyDonor.name ?? this.bloodDonor.name
    },

    donorLabel(){
      return 'Paciente' + ' ' + this.donorName
    },

    donorCPF(){
      return this.serologyDonor.cpf ?? this.bloodDonor.cpf
    },

    currentUser(){
      return currentUser.getUserData()
    },

    hasTwoPermissions(){
        return this.can('cad_serology' && 'cad_blood_group');
    },

    abilities() {
        return this.currentUser.abilities || []
    },

    profile(){
      const profile = this.currentUser.profile
        return profileSlug(profile)
    },

    attachments_type_id() {
      let attachments_type_id = "";
      if (this.profile == 12) {
        attachments_type_id = 4;
      } else if (this.profile == 13) {
        attachments_type_id = 3;
      } else {
        attachments_type_id = this.serologyAttachments.attachments_type_id;
      }
      return attachments_type_id;
    },
  },

  async created() {
    this.items = await getSerologyList(this.profile);

    this.items = this.items.map((x) => ({
      id: parseInt(x.user_id),
      name: x.name,
    }));

    const donorRes = await axios.get(`/donor/no_serology`);
    const attachmentsTypes = await axios.get(`/attachments_type`);
    this.donor = donorRes.data.data ? donorRes.data.data : donorRes.data;
    this.attachmentsTypes = attachmentsTypes.data.data
      ? attachmentsTypes.data.data
      : attachmentsTypes.data;
    this.attachmentsTypes = this.attachmentsTypes.splice(2, 2);
    this.loadTable();
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    setTypeOfDocument(){
      if(this.serologyDonor.id){
        this.serologyAttachments.attachments_type_id = 3
      }else{
        this.serologyAttachments.attachments_type_id = 4
      }
    },

    can(ability) {
      return this.abilities.includes(ability)
    }, 

    permissionToDelete(item) {
      const typeName = item.type_of_attachments.name;

      if (typeName == 'SOROLOGIA') {
        return !this.can('cad_serology');
      }

      if (typeName == 'IMUNOLOGIA') {
        return !this.can('cad_blood_group');
      }
 
      return true;
    },

    addAttachment() {
      if(this.$refs.anexosForm.validate()) {
        this.loadingButton = true;

        const donor_id = this.serologyDonor.id ?? this.bloodDonor.id 

        let anexosData = new FormData();
        anexosData.append(
          "donor_id",
          donor_id
        );
        anexosData.append(
          "attachment_name",
          this.serologyAttachments.attachment_name
        );
        anexosData.append(
          "observations",
          this.serologyAttachments.observations
            ? this.serologyAttachments.observations
            : ""
        );
        anexosData.append("attachment", this.serologyAttachments.attachment);
        anexosData.append("user_id", this.currentUser.id);
        anexosData.append("attachments_type_id", this.attachments_type_id);

        axios
          .post(`/attachments/create`, anexosData)
          .then((response) => {
            this.loadingButton = false;
            this.serologyAttachments.attachment_name = null;
            this.serologyAttachments.attachment = null;
            this.serologyAttachments.observations = null;
            this.serologyAttachments.attachments_type_id = null;
            this.$refs.anexosForm.resetValidation();

            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            setTimeout(() => {
              this.loadTable();
              this.closeSnackBar();
            }, 3000);
          })
          .catch((err) => {
            this.loadingButton = false;
            const msg = err.details.attachment.join("\n");

            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: msg,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });
            setTimeout(() => {
              this.closeSnackBar();
            }, 5000);
          });
      }
    },
  
    downloadAttachment(item) {
      this.loading = true;
      const attachmentId = item.id;

      axios
        .get(`/attachments/download/${attachmentId}`, {
          responseType: "blob",
        })
        .then((response) => {
          let fileType = "";
          if (response.data.type == "application/pdf") fileType = "pdf";
          if (response.data.type == "image/png") fileType = "png";
          if (response.data.type == "image/jpeg") fileType = "jpeg";

          fileDownload(response.data, `doc.${fileType}`);
          this.loading = false;
        });
    },

    loadTable() {
      const donor_id = this.serologyDonor.id ?? this.bloodDonor.id 

      axios.get(`/attachments/byDonor/${donor_id}`).then((response) => {
        this.arquivos = response.data;
      });
    },

    deleteAttachment(item) {
      const attachmentId = item.id;
      axios
        .delete(`/attachments/${attachmentId}`)
        .then((response) => {
          this.loading = true;

          this.changeSnackBarData({
            status: true,
            type: "success",
            titleMessage: response.data.message,
            bodyMessage: "",
            cardColor: "#41916b",
            titleIcon: "mdi-checkbox-marked-circle",
          });

          setTimeout(() => {
            this.loadTable();
            this.closeSnackBar();
          }, 3000);
        })
        .catch((err) => {
          const msg = err.details.attachment.join("\n");

          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Algo deu errado!",
            bodyMessage: msg,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });
          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);
        });
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>
